
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";

import { logo ,darkLogo } from "../../assets";

import ToggleLanguages from "../utils/ToggleLanguages";
import ToggleDark from "../utils/ToggleDark";

import { useStateContext } from "../../context/ContextProvider";

import { LogoutUser } from "../../redux/actions/user";

import Navebar from "./Navebar";
import Navmobile from "./Navmobile";

import {
  HiOutlineMenuAlt3,
  HiOutlineX,
} from "react-icons/hi";

function Header({ active, DropActive }) {

  const pathname = useLocation();

  const [openNavigation, setOpenNavigation] = useState(false);

  const [isScrolled, setIsScrolled] = useState(false);

  const { currentMode } = useStateContext();

  const dispatch = useDispatch();

  const { user, isAuth } = useSelector((state) => state.Users);

  useEffect(() => {

    const handleScroll = () => {

      setIsScrolled(window.scrollY > 20);

    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);

  }, []);

  const toggleNavigation = () => {

    setOpenNavigation(!openNavigation);

  };

  return (
    <>
      <motion.header
        initial={{ y: -120 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6 }}
        className={`
          fixed top-0 left-0 w-full z-[999]
          transition-all duration-500
          ${
            isScrolled
              ? "py-3"
              : "py-5"
          }
        `}
      >

        <div className="container">

          <div
            className={`
              relative
              flex items-center justify-between
              rounded-[2rem]
              border border-white/10
              bg-white/10 dark:bg-black/20
              backdrop-blur-2xl
              shadow-[0_8px_32px_rgba(0,0,0,0.15)]
              px-5 lg:px-8
              transition-all duration-500
              ${
                isScrolled
                  ? "h-[78px]"
                  : "h-[88px]"
              }
            `}
          >

            {/* Glow */}
            <div className="absolute inset-0 rounded-[2rem] bg-gradient-to-r from-color-1/5 via-transparent to-color-3/5 pointer-events-none"></div>

            {/* Logo */}
            <a
              href="/"
              className="relative z-10 flex items-center"
            >

              <img
                src={ currentMode == "Light" ? logo :darkLogo}
                alt="Hayakom"
                className={`
                  object-contain
                  transition-all duration-500
                  ${
                    isScrolled
                      ? "w-[85px]"
                      : "w-[100px]"
                  }
                `}
              />

            </a>

            {/* Desktop Nav */}
            <div className="relative z-10">
              <Navebar
                active={active}
                DropActive={DropActive}
              />
            </div>

            {/* Actions */}
            <div className="relative z-10 flex items-center gap-3 lg:gap-4">

              <div className="hidden sm:flex items-center gap-3">

                <div className="rounded-xl bg-white/10 backdrop-blur-xl border border-white/10 p-2">
                  <ToggleLanguages />
                </div>

                <div className="rounded-xl bg-white/10 backdrop-blur-xl border border-white/10 p-2">
                  <ToggleDark />
                </div>

              </div>

              {/* Mobile Button */}
              <button
                onClick={toggleNavigation}
                className="
                  lg:hidden
                  w-12 h-12
                  rounded-2xl
                  bg-color-1
                  text-white
                  flex items-center justify-center
                  shadow-lg
                "
              >

                {
                  openNavigation
                    ? <HiOutlineX size={24} />
                    : <HiOutlineMenuAlt3 size={24} />
                }

              </button>

            </div>

          </div>

        </div>

      </motion.header>

      {/* Mobile Menu */}
      <AnimatePresence>

        {
          openNavigation && (

            <Navmobile
              active={active}
              DropActive={DropActive}
              setOpenNavigation={setOpenNavigation}
            />

          )
        }

      </AnimatePresence>
    </>
  );
}

export default Header;

